import InPersonIcon from "../../../Shared/InPersonMeetingIcon/In_Person_Icon.png";
 
export default function DiamondModalMapper(mappedUser) {
    if (!mappedUser)
        return null;

    return {
        userId: mappedUser.userId,
        accessLevel: mappedUser.accessLevel,
        iboNum: mappedUser.iboNum,

        iboB: mappedUser.iboB,
        committeesB: mappedUser.committeesB,
        committees: mappedUser.committees,

        canSwap: mappedUser.canSwap,
        
        picture: mappedUser.photo || InPersonIcon,
        name: `${mappedUser.firstName} ${mappedUser.lastName}`,
        phoneNumber: mappedUser.phoneNumber,
        email: mappedUser.email,
        address: mappedUser.address,
        spouse: mappedUser.spouse,
        birthdate: mappedUser.birthdate,
        anniversary: mappedUser.anniversary,
        pinLevel: mappedUser.pinLevel,
        uplineDiamond: mappedUser.uplineDiamond,
        yearDiamondQualified: mappedUser.yearDiamondQualified,
        yearQualified: mappedUser.yearQualified,
        gracePeriod: mappedUser.gracePeriod,
        gracePeriodStarted: mappedUser.gracePeriodStarted,
        familyReunion: mappedUser.familyReunion,
        firstFamilyReunion: mappedUser.firstFamilyReunion,
        familyReunionAttendance: mappedUser.familyReunionAttendance,
        garPoints: mappedUser.garPoints,
        integratedGarPoints: mappedUser.integratedGarPoints,
        diamondRankGar: mappedUser.diamondRankGar,
        diamondRankWwg: mappedUser.diamondRankWwg,
        votingMember: mappedUser.votingMember,
        votingMemberYear: mappedUser.votingMemberYear,
        executiveCommittee: mappedUser.executiveCommittee,
        yearQualifyingRequirements: mappedUser.yearQualifyingRequirements,
        yearExecutiveCommitteeQualified: mappedUser.yearExecutiveCommitteeQualified,
    };
};


